module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Aclens-b1685ae437fbc75300e476c50250557d.svg";